/*-----------------------------------------------------------------------------/
/ Original JS
/-----------------------------------------------------------------------------*/
$(function() {
  dropDown();
  headerBarVisible();
  productSlider();
  cardIconDisplay();
  
  //トップページ
  if ($('.template-index').length) {
    PopupDisplayCtrl();
  }
  //コレクション
  if ($('.template-collection').length) {
    PopupDisplayCtrl();
  }
  //商品詳細
  if ($('.template-product').length) {
    if ($('#り黒箱昔ながらの濃厚熟成塩-６本セット-130g-6本-り-イカの塩辛通販-三陸気仙沼-波座').length == 0) {
      PopupDisplayCtrl();
    }
  }
  //特集一覧
  if ($('#shopify-section-blog-interview-template').length) {
    PopupDisplayCtrl();
  }
  //特集詳細
  if ($('#shopify-section-article-interview-template').length) {
    PopupDisplayCtrl();
  }
  //カート
  if ($('.template-cart').length) {
    updateFreeShippingMessage();
    setupFreeShippingMonitor();
  }

});

/*------------------------------------------------------------
  common ドロップダウン
--------------------------------------------------------------*/
function dropDown() {
  var activeClass="is-active";
  
  $(".js-dropdown-switch").on("click", function() {

    $(this).next('.js-dropdown-content').slideToggle(300, 'swing');//コンテンツ開閉
    $(this).toggleClass(activeClass); //activeを付け替える

  });
}
/*------------------------------------------------------------
  header バーがあったらBodyにClass追加
--------------------------------------------------------------*/
function headerBarVisible(){
  //var headerH = $('.site-header__wrapper').height();
  //console.log(headerH);
  
  var bodyAddClass = function(){
    //console.log('timer');
    //announcement-barが読み込まれてから実行
    if($('.announcement-bar--visible').length){
      $('body').addClass('header-bar-visible');
      clearInterval(timer);
    }
  };
  //一定時間繰り返す
  var timer = setInterval(bodyAddClass, 300);
  
  //1秒でsetIntervalを止める
  setTimeout(function() {
    clearInterval(timer);
  }, 1000);
}

function productSlider(){
  if($('.swiper-container').length){
    var swiper;
    //$(window).load(function() {
      swiper = new Swiper('.swiper-container', {
        speed: 1000,
        slidesPerView: 1,
        loop: true,
        effect: "fade",
        autoplay: {
          delay: 4000,
        },
      });
    //});
  }

}

function cardIconDisplay(){
  $('.icons').each(function() {
    //console.log($(this).find('li').length);
    if($(this).find('li').length === 0){
      $(this).remove();
    }
  });
}

/*------------------------------------------------------------
  【トップ・コレクション・商品・特集一覧・特集詳細】ポップアップ表示
--------------------------------------------------------------*/
function PopupDisplayCtrl() {
  //coolieの値取得
  var popupHideCookie = $.cookie('popupHide');
  //cookieの値がonの場合、かつpopupHideCookieがonではない場合
  if((popupHideCookie !== 'on')){
    //ポップアップ表示
    PopupDisplay();
    //閉じるボタンクリックで24時間Cookie保存
    PopupHideTemporarily();
  }
}
// ポップアップ表示
function PopupDisplay() {
  //ポップアップコンテンツが存在する場合
  if($('#js-top-popup').length){
    //100pxスクロールしたら
    $(window).scroll(function () {
      if ($(this).scrollTop() > 100) {
        //ポップアップコンテンツを表示する
        $('#js-top-popup').addClass('is-show');
      } else {
        //100px以内だったらポップアップコンテンツを非表示にする
        $('#js-top-popup').removeClass('is-show');
      }
    });
  }
}
//閉じるボタンクリックで24時間Cookie保存
function PopupHideTemporarily() {
  //閉じるボタンがある場合
  if($('#js-close-btn').length){
    //閉じるボタンを押したらポップアップを閉じる
    $('#js-close-btn').on('click', function(){
      $('#js-top-popup').removeClass('is-show');
      //cookieにpopupHideという名前でonという値をセット
      $.cookie('popupHide', 'on', { 
        expires: 1, //cookieの有効日数
        path:'/' //有効にするパス
      });
      $(window).off('scroll');
    });
  }
}


// =======================================================
// 送料無料メッセージを更新
// =======================================================
window.updateFreeShippingMessage = function(cartData) {
  const messageWrapper = document.querySelector('.js-cart-message-deliveryfree');
  const messageElement = document.getElementById('js-free-shipping-message');

  if (!messageWrapper || !messageElement) return;

  // 基準額をHTMLのdata属性から取得 (セント単位: 10,000円 = 1000000)
  const FREE_SHIPPING_THRESHOLD = parseInt(messageWrapper.dataset.freeShippingThreshold) || 700000;
  
  // 「送料込み」判定用タグ名、商品にこのタグが付いていれば、価格に関係なく送料無料表示
  const TAG_FOR_FREE_SHIPPING = '送料込み';
  
  // 引数として渡されたカートデータ、またはAPIを叩いて最新を取得
  const fetchPromise = cartData 
    ? Promise.resolve(cartData) 
    : fetch('/cart.js').then(response => response.json());

  fetchPromise.then(cart => {
    const currentTotalPrice = cart.total_price; // セント単位
    let newMessage = '';

    // window.cartProductTags に保存された商品タグ情報を使って、現在カート内に「送料込み」タグを持つ商品があるかチェック
    const hasFreeShippingTag =
      Array.isArray(window.cartProductTags) &&
      cart.items.some(cartItem => {
        const productInfo = window.cartProductTags.find(p => p.id === cartItem.id);
        return productInfo && productInfo.tags.includes(TAG_FOR_FREE_SHIPPING);
      });

    // 送料無料条件の判定とメッセージ分岐
    if (hasFreeShippingTag) {

      // 「送料込み」商品がカートにある場合（価格に関係なく送料無料）
      newMessage = `
        <span class="c-text-red">送料無料で注文いただけます</span>
      `;
    } else if (currentTotalPrice === 0) {

      // カートが空の場合（初期表示など）
      newMessage = '注文合計7,000円で送料無料';
    } else if (currentTotalPrice < FREE_SHIPPING_THRESHOLD) {
        const difference = FREE_SHIPPING_THRESHOLD - currentTotalPrice;
        // 日本円形式でフォーマット
        const formattedDifference = new Intl.NumberFormat('ja-JP', { style: 'currency', currency: 'JPY', minimumFractionDigits: 0 }).format(difference / 100);

        newMessage = `あと「${formattedDifference}」以上で<span class="c-text-red">送料無料</span>`;
    } else {
        newMessage = '<span class="c-text-red">送料無料で注文いただけます</span>';
    }

    // メッセージをHTMLに反映
    messageElement.innerHTML = newMessage;
  }).catch(error => {
    console.error('Error updating free shipping message:', error);
  });
};

// =======================================================
// 数量変更、カート内商品削除時送料無料メッセージを更新
// =======================================================

function setupFreeShippingMonitor() {
  // 数量変更フィールドと削除ボタンに共通のセレクター
  const $cartForm = $('form[action="/cart"]');
  
  // カートフォームが見つからない場合は処理を終了
  if (!$cartForm.length) {
    console.warn('Cart form not found. Message updates may not be fully functional.');
    return;
  }

  // メッセージ更新を1秒遅延させる共通の関数
  function scheduleMessageUpdate() {
    // テーマのAjax処理が完了するのを待つため、1秒遅延
    setTimeout(function() {
        window.updateFreeShippingMessage();
    }, 1000);
  }
  
  // 数量変更イベントの監視 (input[name^="updates"] の変更)
  $cartForm.on('change', 'input[name^="updates"]', function(event) {
    scheduleMessageUpdate();
  });

  // カートアイテム削除イベントの監視 (data-cart-item-delete属性を持つ要素のクリック)
  $cartForm.on('click', '[data-cart-item-delete]', function(event) {
    scheduleMessageUpdate();
  });
}

// ================================================================================
// 【はじめての波座セット】喜びの声コンテンツ「もっと見る」ボタン動き
// ================================================================================


document.addEventListener("DOMContentLoaded", function () {
  const btn = document.getElementById("customerVoiceToggleBtn");
  const content = document.querySelector(".customer-voice .accordion-content");
  // 関数: SPかどうかを判定（768px未満ならSP）
  function isSP() {
    return window.innerWidth < 768;
  }

  // SPのみアコーディオン動作を設定
  if (isSP() && btn && content) {
    btn.addEventListener("click", function () {
      content.style.maxHeight = content.scrollHeight + "px";
      btn.style.display = "none";
    });
  }
});


// =======================================================
// 数量変更・削除したら配送日・時間帯が消える不具合対応
// =======================================================

// window.theme.sections の定義を待つロジック
$(window).on('load', function() {
  if ($('.template-cart').length) {
    if (typeof window.theme !== 'undefined' && typeof window.theme.sections !== 'undefined') {
      //console.log('Sections object loaded. Initializing monitor.');
      setupCartEventMonitor(window.theme.sections);
    } else {
      //console.error('FINAL ERROR: Could not find window.theme.sections. Automatic restoration failed.');
    }
  }
});

// セクションイベントをフックするロジック
function setupCartEventMonitor(sections) {
  sections.on('cart_update_done', function(event, instance, state) {
      
    // 1. APIから最新のカートデータを即座に取得し、正確な属性値を復元に使用
    fetch('/cart.js')
    .then(response => response.json())
    .then(latestCart => {
        
      const dateAttr = latestCart.attributes["配送希望日"];
      const timeAttr = latestCart.attributes["配送時間帯"];
      
      // 2. プルダウンの見た目（DOM）を正しいサーバー属性で強制的に復元
      if (typeof restoreDeliverySelectionAPI === 'function') {
        restoreDeliverySelectionAPI(dateAttr, timeAttr);
      }

      // 3. 復元が完了した（プルダウンに値が入った）のを確認した後、
      //    遅延させて、その正しい値をサーバーに再保存し、属性の永続化を保証する。
      //    （DOM操作完了とイベントの落ち着きを待つ）
      setTimeout(function() {
        if (typeof updateCartAttributes === 'function') {
          updateCartAttributes(); 
          //console.log('Attributes successfully restored and re-saved to server.');
        }
      }, 500); 

    })
    .catch(error => console.error('Failed to fetch cart.js for attribute restoration:', error));

    // 削除リンクの標準動作を妨げないように、カスタム処理を削除
    $(document).off('click', 'a[data-cart-item-delete]');
  });
}